<template>
    <div :id="'module-video-' + dModule.id" class="embed-container">
        <iframe
            width="100%"
            :src="embedSrc"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
export default {
    name: "VideoModule",
    props: {
        data: Object,
    },
    data() {
        return {
            dModule: this.data,
        };
    },
    computed: {
        embedSrc() {
            let provider = this.dModule.data.provider;
            let videoId = this.dModule.data.videoId;
            let embed = null;

            if (provider == "youtube") {
                embed =
                    "https://www.youtube.com/embed/" +
                    videoId +
                    "?modestbranding=1&showinfo=0";

                if (this.dModule.data.loop)
                    embed += "&loop=1&playlist=" + videoId;

                embed += "&mute=" + (this.dModule.data.mute ? "1" : "0");
            } else if (provider == "vimeo") {
                embed =
                    "https://player.vimeo.com/video/" +
                    videoId +
                    "?title=0&byline=0&portrait=0&badge=0";

                embed += "&loop=" + (this.dModule.data.loop ? "1" : "0");

                embed += "&muted=" + (this.dModule.data.mute ? "1" : "0");
            }

            if (embed) {
                embed +=
                    "&controls=" + (this.dModule.data.controls ? "1" : "0");

                embed +=
                    "&autoplay=" + (this.dModule.data.autoplay ? "1" : "0");
            }

            return embed;
        },
    },
};
</script>

<style scoped>
.embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
